import React from "react";
import IntroImage from "../../images/about/intro.png";
import MissionImage from "../../images/about/mission.png";
import AboutImage from "../../images/about/about.png";
import { OuterWrapper, InnerWrapper } from "../wrapper/wrapper";
import { Box, Grid, Stack } from "@mui/material";
import {
  Description,
  ExploreButton,
  MiniTitle,
  Title,
} from "./about.components";

function AboutUs() {
  return (
    <OuterWrapper sx={{ bgcolor: "#F8FBFE" }}>
      <InnerWrapper mt={5.5} mb={11}>
        <Grid container alignItems="flex-end" p={1.25}>
          <Grid item xs={12} md={5.5}>
            <Title>Who we are</Title>
            <Description>
              Xpverse is a knowledge and skill acquisition platform that aims to
              prepare today's youngsters for professional employment. While we
              agree that knowledge is crucial, we at Xpverse feel that knowledge
              alone is insufficient to survive in today's professional
              environment. As a result, we provide all of our students with not
              just the essential information, but also the necessary
              industry-relevant skills and practical experience to begin
              successful and gratifying careers in their fields of interest.
            </Description>
          </Grid>
          <Grid xs={0} md={1} />
          <Grid item xs={12} md={5.5}>
            <Box
              component="img"
              src={IntroImage}
              alt=""
              sx={{
                width: "100%",
                height: { xs: "100%", sm: 400 },
                mt: { xs: 3, md: 0 },
              }}
            />
          </Grid>
        </Grid>
      </InnerWrapper>

      <OuterWrapper sx={{ bgcolor: "#EAEEF2" }}>
        <InnerWrapper py={8}>
          <Mission />
        </InnerWrapper>
      </OuterWrapper>

      <InnerWrapper py={12}>
        <Grid container p={1.25}>
          <Grid item xs={12} md={3.5}>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Title>An Exceptionally unique experience tailored to you</Title>
              <Description sx={{ mt: "5px" }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna{" "}
              </Description>
              <ExploreButton sx={{ mb: { xs: 3, md: 0 } }}>
                Explore now
              </ExploreButton>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4.5}>
            <Box
              component="img"
              src={AboutImage}
              alt=""
              sx={{
                width: "100%",
                height: { xs: "100%", sm: 462 },
              }}
            />
          </Grid>
          <Grid item xs={12} md={0.5} sx={{ mt: { xs: 3, md: 0 } }} />
          <Grid item xs={12} md={3.5}>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={3.75}
            >
              <Box>
                <MiniTitle sx={{ mb: "17px" }}>Our Students</MiniTitle>
                <Description>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore
                </Description>
              </Box>
              <Box>
                <MiniTitle sx={{ mb: "17px" }}>Our Internships</MiniTitle>
                <Description>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore
                </Description>
              </Box>
              <Box>
                <MiniTitle sx={{ mb: "17px" }}>Our Mentors</MiniTitle>
                <Description>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore
                </Description>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </InnerWrapper>
    </OuterWrapper>
  );

  function Mission() {
    return (
      <Grid container alignItems="flex-end" p={1.25}>
        <Grid item xs={12} md={5.5}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={6}
          >
            <Box>
              <MiniTitle sx={{ mb: "27px" }}>Our Goal</MiniTitle>
              <Description>
                Our goal is to transform the educational landscape. We want
                teaching to become a practise in which students learn the
                practical skills they need to be adaptable, inventive,
                confident, and productive. Instead of emphasising the link
                between grades and success, we want to emphasise the link
                between skills and achievement. We strive to make every one of
                our students skilled and seasoned professionals from the minute
                they step foot in the workplace, thanks to our cutting-edge
                curriculum, internships, and project experience.
              </Description>
            </Box>
            <Box
              component="img"
              src={MissionImage}
              alt=""
              sx={{
                width: "100%",
                height: { xs: "100%", sm: 234 },
                pb: { xs: 3, md: 0 },
              }}
            />
          </Stack>
        </Grid>
        <Grid xs={0} md={1} />
        <Grid item xs={12} md={5.5}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={6}
          >
            <Box>
              <MiniTitle sx={{ mb: "27px" }}>Our Mission</MiniTitle>
              <Description>
                We have gotten fascinated with markings as a culture. Marks, it
                is believed, are closely related to a successful career. What we
                need now, more than ever, is competent, experienced young
                individuals who can make an immediate impact on their
                businesses. Our mission at Xpverse is to provide opportunities
                for today's youngsters to learn and grow. Our internships and
                industry-relevant projects ensure that they enter the profession
                with the skills and knowledge they need to succeed.
              </Description>
            </Box>
            <Box>
              <MiniTitle sx={{ mb: "27px" }}>Our Vision</MiniTitle>
              <Description>
                We believe that a more bright future is achievable. At Xpverse,
                we believe that a better professional is someone who, on day
                one, not only has theoretical knowledge, but also has an amazing
                skill set and past experience. Our mission is to empower today's
                youth by broadening their perspectives, developing them as
                people, and providing them with the job experience they need to
                enter the workforce and make an instant impact.
              </Description>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    );
  }
}

export default AboutUs;
